import { WarningAmber } from '@mui/icons-material';

const WarningOutline = (): JSX.Element => <WarningAmber fontSize="inherit" />;

export default WarningOutline;
